import React from "react";
import { Dialog, DialogTitle, DialogContent, Box, Typography, LinearProgress, CircularProgress } from "@mui/material";

const UploadProgressLoader = ({
  open,
  folderName = "",
  totalFiles = 0,
  uploadedFiles = 0,
  currentFileName = "",
  currentFileProgress = 0,
  isUploading = true,
  title = "Uploading..."
}) => {
  // Calculate overall progress percentage
  const overallProgress = totalFiles > 0 ? ((uploadedFiles / totalFiles) * 100) : 0;

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {/* {folderName && (
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
            Folder: {folderName}
          </Typography>
        )} */}

        {isUploading ? (
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={3}>
            <CircularProgress
              size={80}
              thickness={4}
              sx={{
                color: "#FF9800",
                "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
              }}
            />
            <Typography variant="body2" sx={{ mt: 2 }}>
              Uploading file {uploadedFiles + 1} of {totalFiles}
            </Typography>
            <Typography variant="body2">{currentFileName || "-"}</Typography>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            {/* Overall progress */}
            <Box>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Overall Progress: {Math.round(overallProgress)}%
              </Typography>
              <LinearProgress
                variant="determinate"
                value={overallProgress}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  mt:2,
                  backgroundColor: "#f0f0f0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: overallProgress < 80 ? "#2196F3" : "#4CAF50",
                  },
                }}
              />
            </Box>

            {/* Current file progress */}
            {/* <Box>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                Current File: {currentFileName || "-"} ({Math.round(currentFileProgress)}%)
              </Typography>
              <LinearProgress
                variant="determinate"
                value={currentFileProgress}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: "#f0f0f0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: currentFileProgress < 80 ? "#FF9800" : "#4CAF50",
                  },
                }}
              />
            </Box> */}

            <Typography variant="body2" sx={{ mt: 1 }}>
              Files Uploaded: {uploadedFiles} / {totalFiles}
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default UploadProgressLoader;
